import newWindowIcon from '@SvgIcon/android-open.svg'
import searchIcon from '@SvgIcon/search.svg'

import $ from 'jquery'
import debounce from 'lodash/debounce'
import Mousetrap from 'mousetrap'
import Vue from 'vue'
import svgIconHtml from '../../../shared/svgIconHtml'
import { setupModal } from '../../_modal'

const SearchComponent = Vue.extend({
  // language=HTML
  template: `
    <div>
      <form class="search-form" :action="searchUrl" method="get" @submit.prevent="doSearch">
        <div class="modal-search-app__query">
          <div class="modal-search-app__query-field-wrap">
            ${svgIconHtml(searchIcon, 'modal-search-app__query-icon')}
            <input
              v-model="keywords"
              type="text"
              name="query"
              class="modal-search-app__query-input"
              placeholder="Search"
              aria-label="Search query"
            />
          </div>
          <button type="submit" class="button modal-search-app__query-button show-for-sr">
            Search
          </button>
        </div>
        <fieldset class="modal-search-app__targets" v-if="searchTargets.length > 1">
          <legend class="show-for-sr">Search in</legend>
          <div v-for="searchTarget in searchTargets" :key="searchTarget.key" class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" name="indexes[]" :value="searchTarget.key"
                v-model="indexes">
              {{ searchTarget.caption }}
            </label>
          </div>
        </fieldset>
      </form>

      <div class="modal-search-app__results">
        <div v-if="searching" class="modal-search-app__progress">
          <ui-progress-circular :size="64" :indeterminate="true" />
        </div>

        <div class="modal-search-app__empty-state" v-if="!searching && !hasSearched">
          <div class="modal-search-app__empty-state-icon">🔍</div>
          <p class="modal-search-app__empty-state-title">Start searching</p>
          <p class="modal-search-app__empty-state-description">Enter keywords to search the site.</p>
        </div>

        <template v-if="!searching && hasSearched">
          <div v-if="!results.length" class="no-results">
            <p>
              Your search - <b>{{ keywords }}</b> - did not match any documents.
            </p>

            <p>
              Suggestions:
            </p>

            <ul>
              <li>Make sure all words are spelled correctly.</li>
              <li>Try different keywords.</li>
              <li>Try more general keywords.</li>
            </ul>
          </div>
          <div class="modal-search-app__search-result-list" v-else>
            <a
              v-for="result in results"
              :href="result.url ? result.url : 'javascript:void(0)'"
              :target="result.newWindow ? '_blank' : '_self'"
              class="modal-search-app__search-result"
            >
              <div v-if="result.photo" class="modal-search-app__search-result-thumbnail">
                <img :src="result.photo" alt="">
              </div>
              <div v-else class="modal-search-app__search-result-thumbnail is-generic">
                📄
              </div>
              <div class="modal-search-app__search-result-info">
                <div class="modal-search-app__search-result-title">
                  {{ result.title }}
                  <template v-if="result.url && result.newWindow">
                    ${svgIconHtml(newWindowIcon)}
                  </template>
                </div>
                <div v-if="result.description" class="modal-search-app__search-result-description">
                  {{ result.description }}
                </div>
                <div v-if="result.crumbs.length" class="modal-search-app__search-result-crumbs">
                  {{ joinCrumbs(result.crumbs) }}
                </div>
              </div>
            </a>
          </div>
        </template>
      </div>
    </div>
  `,
  props: {
    searchUrl: {
      type: String,
      required: true,
    },
    searchTargets: {
      type: Array,
    },
  },
  data() {
    return {
      keywords: '',
      indexes: this.searchTargets
        .filter((searchTarget) => searchTarget.default)
        .map((searchTarget) => searchTarget.key),
      searching: false,
      hasSearched: false,
      results: [],
    }
  },
  watch: {
    keywords() {
      this.doDebouncedSearch()
    },
    indexes() {
      this.doDebouncedSearch()
    },
  },
  methods: {
    doSearch() {
      if (this.searchXhr) {
        this.searchXhr.abort()
      }

      if (this.keywords === '') {
        this.setResults([])
        return
      }

      this.searching = true
      this.searchXhr = $.ajax({
        type: 'GET',
        url: this.searchUrl,
        data: {
          query: this.keywords,
          indexes: this.indexes,
          from: document.location.pathname,
        },
      })
        .always(() => {
          this.searching = false
        })
        .done((results) => {
          this.setResults(results)
        })
        .fail((xhr) => {
          if (xhr.responseJSON && 'redirect' in xhr.responseJSON) {
            document.location.href = xhr.responseJSON.redirect
          }
        })
    },

    doDebouncedSearch: debounce(function search() {
      this.doSearch()
    }, 200),

    setResults(results) {
      if (this.keywords === '') {
        this.hasSearched = false
        this.results = []
        return
      }

      this.hasSearched = true
      this.results = results
    },

    joinCrumbs(crumbs) {
      return crumbs.join(' > ')
    },
  },
  created() {
    this.searchXhr = null
  },
})

if (document.getElementById('modal-search-app')) {
  new Vue({
    name: 'SearchModal',
    el: '#modal-search-app',
    render(h) {
      return h(SearchComponent, {
        props: {
          searchUrl: this.$el.attributes['data-search-url'].value,
          searchTargets: JSON.parse(this.$el.attributes['data-search-targets'].value),
        },
      })
    },
  })
}

const $searchModal = $('#modal-search')
if ($searchModal.length) {
  const modal = setupModal($searchModal)

  $searchModal.on('open.zf.reveal', () => {
    setTimeout(() => {
      $searchModal.find('input:first').focus()
    }, 50)
  })

  Mousetrap.bind('ctrl+/', () => {
    modal.open()
  })
}
